import ChatGptAlternativePage from '@/components/Pages/ChatGptAlternativePage';

export default ChatGptAlternativePage;
